
<template>
  <div class="the-navbar__user-meta flex items-center" v-if="userInfo.username">
<!--
修改为点击之后菜单收起来
-->
    <el-dropdown
      trigger="hover"
      class="cursor-pointer"
      @command="handleCommand"
      :hide-on-click="true"
    >
      <div class="con-img ml-3">
        <img v-if="userInfo.avatar" key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
        <first-letter
          v-else
        ></first-letter>
      </div>

      <el-dropdown-menu
        :style="menuStyle"
        slot="dropdown" class="vx-navbar-dropdown">
        <el-dropdown-item
          class="user-info border-bottom-li py-2 px-4 cursor-pointer self-dropdown-item"
        >
          <div class="user-name">{{userInfo.firstName}}{{userInfo.lastName}}</div>
          <div class="tag-box">ID:{{userInfo.id}}</div>
        </el-dropdown-item>
        <el-dropdown-item
          v-if="userInfo.custType == 1"
          class="toggle-li py-2 px-4 cursor-pointer self-dropdown-item"
          @click="toggleHandle"
          command="a"
        >
          <icon-svg
            icon-class="qiehuan"
            class="icon-el w-4 h-4"
          />
          <span class="">{{toggleText}}</span>
        </el-dropdown-item>
        <el-dropdown-item
          command="b"
          class="flex py-2 px-4 cursor-pointer self-dropdown-item"
          @click="logout"
        >
          <feather-icon class="feather-icon-el" icon="LogOutIcon" svgClasses="" />
          <span class="">{{$t('sign_out')}}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { IBToggleHandle } from '@/utils/index'
  import firstLetter from '@/components/public/firstLetter'
import { mapGetters } from 'vuex'
export default {
    components:{
      firstLetter,
    },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['userInfo','agentRole','language','listRefresh']),
    menuStyle(){
      if(this.language == 'en_US'){
        return {
          minWidth: '13rem'
        }
      }else {
        return {
          minWidth: '9rem'
        }
      }
    },
    activeUserInfo() {
      return this.$store.getters.AppActiveUser
    },
    firstLetter(){
      return this.userInfo.username.toUpperCase().charAt(0);
    },
    toggleText(){
      if(this.agentRole == 'IB'){
        return this.$t('navBar.Switch_to_customer');
      }else {
       return this.$t('navBar.Switch_to_IB');
      }
    }
  },
  methods: {
    logout() {
      // This is just for demo Purpose. If user clicks on logout -> redirect
      localStorage.clear();
      this.$router.push({name: 'login'}).catch(() => {})
    },
    toggleHandle(){
      IBToggleHandle(this);
    },
    handleCommand(command){
      if(command == 'a'){
        this.toggleHandle();
      }else if(command == 'b'){
        this.logout();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../assets/scss/variable";
.self-dropdown-item {
  &:hover {
    color: $themeColor;
  }
  .user-name {
    font-weight: 600;
    font-size: 14px;
    color: #5E5873;
  }
  .icon-el {
    font-size: 16px;
    margin-right: 10px;
  }
  .feather-icon-el {
    margin-right: 10px;
    > svg {
      width: 1.2rem;
      height: 1.2rem;
    }
  }
}

.border-bottom-li {
  border-bottom: 1px solid #EBE9F1;
  .tag-box {
    margin-top: 5px;
    background-color: rgba(186, 191, 199, 0.12);
    padding: 3px 5px;
    border-radius: 15px;
    text-align: center;
  };
}
.vs-dropdown--custom {

}
.user-name-p {
  padding-left: 5px;
}
</style>
<style lang="scss">
.self-dropdown-item:not(.is-disabled):hover {
  background-color: #ffffff!important;
}
.self-dropdown-item {
  line-height: 1.5!important;
}
</style>
